'use strict';

import appData from '../app-data/app-data';
import performance from '../performance/performance';

function startLoadTime(appName) {
  return appData.getStartLoadTime(appName) || 0;
}

function endLoadTime() {
  return performance.now();
}

/**
 * calculates the app load time
 */
export default {
  appLoadTime(appName) {
    return endLoadTime() - startLoadTime(appName);
  },

  loadStarted(appName) {
    appData.setStartLoadTime(appName, performance.now());
  },

  firstRequestDuration(appName) {
    return startLoadTime(appName);
  }
};



// WEBPACK FOOTER //
// ./time/time.js